import { IImageLibraryDto } from "@kuika/kuika-cl-model";
import * as React from "react";
import { ImageLibraryService } from "../../../../services/image-library-service";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { FilePicker } from "../../../common/file-picker";

export interface IPropertyFormImageState {
  allImage: IImageLibraryDto[];
  isDataLoading: boolean;
}

export interface IPropertyFormImageProps {
  onChange: (value: string, image: IImageLibraryDto) => void;
  selectedId: string;
  disabled?: boolean;
}

class PropertyFormImage extends React.PureComponent<IPropertyFormImageProps, IPropertyFormImageState> {
  constructor(props: IPropertyFormImageProps) {
    super(props);
    this.state = {
      allImage: [],
      isDataLoading: true
    };
  }

  getImageLibrary = async (): Promise<void> => {
    this.setState({ isDataLoading: true });
    try {
      const res = await ImageLibraryService.GetAll();
      if (res && res.status === 200) {
        this.setState({ allImage: res.data });
      }
    } catch (error: unknown) {
      KMainFunctions.exceptionHandler(error);
    } finally {
      this.setState({ isDataLoading: false });
    }
  };

  componentDidMount = (): void => {
    void this.getImageLibrary();
  };

  render(): React.ReactNode {
    return (
      <FilePicker
        files={this.state.allImage}
        onChange={this.props.onChange}
        getImageLibrary={this.getImageLibrary}
        isLoading={this.state.isDataLoading}
        acceptedFileTypes=".jpg,.png,.svg,.xml"
        fileSize={5}
        enableGenerateWithAI={!KMainFunctions.isMainAI()}
        showFileDragger={KMainFunctions.isMainAI()}
        isDeleteEnabled
        selectedId={this.props.selectedId}
        disabled={this.props.disabled}
      />
    );
  }
}

const propertyFormImage = PropertyFormImage;
export { propertyFormImage as PropertyFormImage };
